import {Model} from 'common'
Model.define('model.templateInfo', {
  proxy: {
    get: '/cpu-supplymgr/greenChannel/selectById',
    post: '/cpu-supplymgr/greenChannel/save'
  },
  meta: {
    id: '',
    classId: '', // 所属模板ID
    className: '', // 所属目标名称
    code: '', // 模板编码
    name: '', // 模板名称
    createOrgId: '',
    createOrgName: '',
    creator: '',
    creatorName: '',
    description: '', // 模板描述
    enableStatus: '',
    modifier: '',
    modifierName: '',
    templetId: '',
    templetType: ''// 模板类型
  }
})

export default Model.create('model.templateInfo')



// WEBPACK FOOTER //
// ./src/data/model/templateInfo/index.js